// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"812c15c6","218":"86553870","366":"110f4901","482":"f9781fd6","503":"54a1e446","534":"9327781d","579":"95bb2b9d","793":"dd0f6319","910":"9434e010","998":"331382c3"}[chunkId] + ".chunk.js";
};